export const truncateString = (string, maxLength, separator = ' ') =>
	string.substr(0, string.lastIndexOf(separator, maxLength)) ||
	string.substr(0, maxLength);
